import { createNavigation } from 'next-intl/navigation';

export const locales = ['pl'] as const;
export const LOCALE_PREFIX = 'always';

const {
  redirect,
  Link: NextIntlLink,
  usePathname,
  useRouter,
} = createNavigation({
  locales,
  localePrefix: LOCALE_PREFIX,
});

const Link = ({ prefetch = false, ...rest }: Parameters<typeof NextIntlLink>[0]) => {
  return <NextIntlLink {...rest} prefetch={prefetch} />;
};

export { Link, redirect, usePathname, useRouter };
